import { isValidNumber, ObjectAccessor } from '@dateam/ark';
import { parseObservationField } from './shared';
import { RecordValue, ValidationError } from './types';

/*
 ** Cochenille
 ** - count: Comptage // /25 ceps
 **     0 <= Value <= 25
 ** - total: Total /10 feuilles
 */

type CurrentObservation = App.Observation23;
type CurrentApiObservation = App.Api.Observation23;

export const validate = (
    observation: CurrentObservation,
    _: App.Plot
): Record<never, never> | Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError> => {
    const validation = {} as Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError>;

    const { ignored, count, total } = observation;

    if (ignored === true) return validation;

    if (count != null) {
        if (!isValidNumber(count) || count < 0 || count > 25) {
            validation.count = {
                field: 'count',
                type: 'error',
                code: 'format'
            };
        }
    }

    if (total != null) {
        if (!isValidNumber(total) || total < 0) {
            validation.total = {
                field: 'total',
                type: 'error',
                code: 'format'
            };
        }
    }

    return validation;
};

export const parse = (observation: CurrentApiObservation): CurrentObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        count,
        total
    } = observation;
    const parsedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        isSyncing: false,
        isValid: true,
        hasChanged: false
    } as CurrentObservation;

    parsedObs.count = parseObservationField(count);
    parsedObs.total = parseObservationField(total);

    return parsedObs;
};

export const map = (observation: CurrentObservation): CurrentApiObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        count,
        total
    } = observation;
    const mappedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn
    } as CurrentApiObservation;

    mappedObs.count = count !== undefined ? new RecordValue(count) : null;
    mappedObs.total = total !== undefined ? new RecordValue(total) : null;

    return mappedObs;
};